import { post } from '../../api/client';
import type { ApiResult } from '../../api/types';

export interface CategoryItem {
    id: number;
    label: string;
    rank: number | null;
    url_identifier: string;
    category: string;
}

export interface CategoryUpdateInput {
    category: string;
    id: number | null;
    label: string;
    rank: number | null;
    url_identifier: string;
}

// `_token` is kept for call-site compatibility — the typed client picks the
// admin token up from the pgAdminToken cookie via its request interceptor.
export const GetValuesByCategory =
    (_token: string, payload: { category: string }) =>
    async (_dispatch: unknown): Promise<ApiResult<CategoryItem[]>> =>
        post<CategoryItem[]>('/admin/getValuesByCategory', payload);

export const AddOrUpdateCategory =
    (_token: string, categoryData: CategoryUpdateInput) =>
    async (_dispatch: unknown): Promise<ApiResult<CategoryItem>> =>
        post<CategoryItem>('/admin/updateOrAddValue', {
            category: categoryData.category,
            id: categoryData.id || null,
            label: categoryData.label,
            rank: categoryData.rank,
            url_identifier: categoryData.url_identifier
        });
